import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetEmspUsersInvoicesPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users-invoices/get-emsp-users-invoices-paginated.form-validation';
import { GetEmspUsersInvoicesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users-invoices/get-emsp-users-invoices-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { EmspBoInvoiceStatusFilterController } from '../../emsp-bo-invoice-status-filter/emsp-bo-invoice-status-filter.controller';
import { EmspBoInvoiceTypeFilterController } from '../../emsp-bo-invoice-type-filter/emsp-bo-invoice-type-filter.controller';

const EmspBoInvoiceListFilterFormStep1StatusFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    // const { t } = useTranslation();
    const { control } = useFormContext<GetEmspUsersInvoicesPaginatedModel>();
    const { status } = useGetEmspUsersInvoicesPaginatedFormValidation();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <>
        <Controller
          name="status"
          control={control}
          rules={status}
          render={({ field /* , fieldState: { error } */ }) => {
            const values: string[] = [];

            if (Array.isArray(field.value)) {
              values.push(...field.value);
            } else if (field.value) {
              values.push(field.value);
            }

            return (
              <EmspBoInvoiceStatusFilterController
                selectedItemIds={values}
                onChange={(value) => field.onChange(value)}
              />
            );
          }}
        />
        <Divider />
      </>
    );
  };

const EmspBoInvoiceListFilterFormStep1TypeFragment = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetEmspUsersInvoicesPaginatedModel>();
  const { type } = useGetEmspUsersInvoicesPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Controller
      name="type"
      control={control}
      rules={type}
      render={({ field /* , fieldState: { error } */ }) => {
        const values: string[] = [];

        if (Array.isArray(field.value)) {
          values.push(...field.value);
        } else if (field.value) {
          values.push(field.value);
        }

        return (
          <EmspBoInvoiceTypeFilterController
            selectedItemIds={values}
            onChange={(value) => field.onChange(value)}
          />
        );
      }}
    />
  );
};

export const EmspBoInvoiceListFilterFormStep1Controller =
  (): React.JSX.Element => {
    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Stack
        direction="row"
        justifyContent="stretch"
        alignItems="stretch"
        flex={1}
        gap={GapEnum.M}>
        <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.M}>
          <EmspBoInvoiceListFilterFormStep1StatusFragment />
          <EmspBoInvoiceListFilterFormStep1TypeFragment />
        </Stack>
      </Stack>
    );
  };
